<template>
    <div class="c-m-queued-companies" :class="{ 'c-m-queued-companies--with-button': !showButton }">
        <p class="c-m-queued-companies__heading h4">Valda företag</p>
        <ul class="c-m-queued-companies__items">
            <transition-group name="c-m-queued-companies__item--animation">
                <li class="c-m-queued-companies__item" v-for="(company) in queuedCompanies" :key="company.Id">
                    <router-link class="c-m-queued-companies__link" :to="`/hantverkare/${company.Id}/`">
                        <span v-if="company.Logo" class="c-m-queued-companies__logo">
                            <img :src="company.Logo" :alt="company.Name">
                            <span class="c-m-queued-companies__logo-bg"
                                :style="`background-image: url(${company.Logo})`"></span>
                        </span>
                        <span class="c-m-queued-companies__label">{{ company.Name }}</span>
                    </router-link>
                    <atom-button :icon="'close'" @buttonClicked="removeCompany(...[company.Id])"
                        class="c-a-button--theme-alert c-a-button--small c-a-button--icon-only"></atom-button>
                </li>
            </transition-group>
        </ul>
        <div v-if="!showButton" class="c-m-queued-companies__button">
            <button-link :icon="'arrow_forward'" class="c-a-button--theme-primary c-a-button--small "
                :link="'/skapa-forfragan/'" label="Skapa direktförfrågan"></button-link>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
    GET_COMPANIES,
    GET_ERROR,
    REMOVE_FROM_QUEUE
} from '../../../store/store-models/queued-companies-model';

import AtomButton from './../atoms/AtomButton.vue';
import ButtonLink from './../atoms/AtomButtonLink.vue';
import Icon from './../atoms/AtomIcon.vue';

export default {
    props: {
        showButton: Boolean
    },
    components: {
        AtomButton,
        ButtonLink,
        Icon
    },
    computed: {
        ...mapGetters({
            queuedCompanies: GET_COMPANIES,
            error: GET_ERROR,
        }),
    },
    methods: {
        ...mapActions({
            removeFromQueue: REMOVE_FROM_QUEUE
        }),
        removeCompany(id) {
            this.removeFromQueue(id)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeQueuedCompanies.vue